<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">倉庫明細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="successShipments.length === 0" @click="save()"
          >保存</v-btn
        >
        <v-btn @click="$router.go(-1)">戻る</v-btn>
      </v-card-actions>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex md3 sm6 xs12>
            <remote-autocomplete
              label="納入場所"
              url="warehouses/reservable-kv"
              v-model="query.warehouseId"
            ></remote-autocomplete>
          </v-flex>
          <v-flex md3 sm6 xs12>
            <remote-autocomplete
              label="所属事業本部"
              clearable
              v-model="query.buId"
              url="/divisions/kv?type=BU"
            />
          </v-flex>
          <v-flex md3 sm6 xs12>
            <remote-autocomplete
              label="所属BU"
              clearable
              v-model="query.businessUnitId"
              url="/divisions/kv?type=BUSINESS_UNIT"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-card>
      <v-card-text>
        <h3 style="margin: 20px">おまかせ予約情報</h3>
        <div class="row-0">
          <div
            style="padding: 15px 20px"
            v-if="successShipments.length === 0 && failedShipments.length === 0"
          >
            <div style="display: flex; width: 100%">
              <label style="font-weight: bold; width: 80px">BL No:</label>
              <span>{{ $route.query.shipments[0].blNo }}</span>
            </div>
            <div>
              <div style="display: flex; width: 100%">
                <label style="font-weight: bold; width: 80px">Container:</label>
                <span
                  :title="shipment.containerNo"
                  class="over-content"
                  v-for="shipment in $route.query.shipments"
                  :key="shipment.id"
                >
                  {{ shipment.containerNo }}
                </span>
              </div>
              <div style="display: flex; width: 100%">
                <label style="font-weight: bold; width: 80px">品種名:</label>
                <span
                  :title="shipment.productName"
                  class="over-content"
                  v-for="shipment in $route.query.shipments"
                  :key="shipment.id"
                >
                  {{ shipment.productName }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="col-0"
            v-if="
              $route.query.type &&
              (successShipments.length > 0 || failedShipments.length > 0)
            "
          >
            <div>
              <div>
                <table style="margin: 0 10px">
                  <tr>
                    <th class="header">納入場所</th>
                    <th class="header">納入予定日</th>
                    <th class="header">Container No</th>
                    <th class="header">品種名</th>
                    <th class="header">予約状況</th>
                    <th class="header">コメント</th>
                  </tr>
                  <tr
                    v-for="successShipment in successShipments"
                    :key="successShipment.id"
                    class="row-1"
                  >
                    <td>
                      <div style="height: 20px !important">
                        {{
                          successShipment &&
                          successShipment.setting.warehouseName
                        }}
                      </div>
                    </td>
                    <td>
                      <div style="height: 20px !important">
                        {{ successShipment && successShipment.setting.date }}
                      </div>
                    </td>
                    <td>
                      <span
                        :title="successShipment.shipment.containerNo"
                        class="over-content"
                        style="height: 20px !important"
                      >
                        {{ successShipment.shipment.containerNo }}
                      </span>
                    </td>
                    <td
                      class="over-content"
                      style="max-width: 140px !important"
                    >
                      <span
                        style="height: 20px !important"
                        :title="successShipment.shipment.productName"
                        class="over-content"
                      >
                        {{ successShipment.shipment.productName }}
                      </span>
                    </td>
                    <td>
                      <div style="height: 20px !important">成功</div>
                    </td>
                    <td>
                      <div style="height: 20px !important">
                        <input
                          style="
                            min-width: 500px;
                            border-bottom: 1px solid black;
                          "
                          type="text"
                          v-model="successShipment.shipment.remark"
                        />
                        <!-- <v-text-field style="min-width:500px;" v-model="successShipment.shipment.remark"></v-text-field> -->
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="failedShipment in failedShipments"
                    :key="failedShipment.id"
                    class="row-1"
                  >
                    <td></td>
                    <td></td>
                    <td>
                      <span
                        :title="
                          failedShipment && failedShipment.containerNo
                        "
                        class="over-content"
                        style="height: 20px !important"
                      >
                        {{
                          failedShipment && failedShipment.containerNo
                        }}
                      </span>
                    </td>
                    <td
                      class="over-content"
                      style="max-width: 140px !important"
                    >
                      <span
                        style="height: 20px !important"
                        :title="failedShipment && failedShipment.productName"
                        class="over-content"
                      >
                        {{ failedShipment && failedShipment.productName }}
                      </span>
                    </td>
                    <td>失敗</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <fixed-column-wrap :data="displayResults">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="displayResults"
            :loading="loading"
            :rows-per-page-items="[-1]"
            item-key="[0].id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-if="false"
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{ getWarehouse(props.item[0]) }}
              </td>
              <td>
                {{ getBu(props.item[0]) }}
              </td>
              <td>
                {{ getBusinessUnit(props.item[0]) }}
              </td>
              <td>
                <div v-for="item in getProductGroup(props.item)" :key="item.id">
                  {{ item[0].productGroupName }}
                </div>
              </td>

              <td v-for="date in availableDays" :key="date">
                <div class="qtyLeft">
                  <div>
                    <div
                      class="qty"
                      v-for="item in getProductGroup(props.item)"
                      :key="item.id"
                    >
                      {{ getUpperLimit(date, item) }}
                    </div>
                  </div>
                  <v-btn
                    class="btn-search"
                    @click="muliplyReserve(props.item, date)"
                    v-if="
                      $route.query.type === 'multiply' &&
                      canReserve(props.item, date)
                    "
                    >予約</v-btn
                  >
                </div>
              </td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="virtualHeaders"
        :items="virtualDisplayResults"
        :loading="loading"
        :rows-per-page-items="[-1]"
        item-key="[0].id"
        v-model="selected"
        select-all
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-if="false"
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>
            {{ getWarehouse(props.item[0]) }}
          </td>
          <td>
            {{ getBu(props.item[0]) }}
          </td>
          <td>
            {{ getBusinessUnit(props.item[0]) }}
          </td>
          <td>
            <div v-for="item in getProductGroup(props.item)" :key="item.id">
              {{ item[0].productGroupName }}
            </div>
          </td>

          <td v-for="date in virtualAvailDays" :key="date">
            <div class="qtyLeft">
              <div>
                <div
                  class="qty"
                  v-for="item in getProductGroup(props.item)"
                  :key="item.id"
                >
                  {{ getUpperLimit(date, item) }}
                </div>
              </div>
              <v-btn
                class="btn-search"
                @click="muliplyReserve(props.item, date)"
                v-if="canVirtualReserve(props.item, date)"
                >予約</v-btn
              >
            </div>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      user: {},
      remark: '',
      successShipments: [],
      failedShipments: [],
      selected: [],
      results: [],
      availableDays: [],
      workingAvailableDays: [],
      basicAvailableDays: [],
      displayResults: [],
      virtualDisplayResults: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
      headers: [
        {
          text: '納入場所',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '事業本部',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: 'BU',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '品種グループ',
          value: '',
          sortable: false,
          class: 'fixed',
        },
      ],
      date: new Date(),
      errors: {
        NO_PRODUCT_GROUP:
          '品種グループが登録されていないので、利用可能倉庫が見つかりません。',
        NO_LIMIT: '当該倉庫に品種グループが登録されていません。',
        QTY_OVER: '予約可能本件を超えました。',
      },
      currentData: null,
      currentDate: null,
      shipment: {},
      originResults: [],
      virtualAvailDays: [],
      virtualWarehouses: [],
      virtualHeaders: [
        {
          text: '納入場所',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '事業本部',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: 'BU',
          value: '',
          sortable: false,
          class: 'fixed',
        },
        {
          text: '品種グループ',
          value: '',
          sortable: false,
          class: 'fixed',
        },
      ],
      currentResultsIndex: null,
    }
  },
  methods: {
    load() {
      var id = this.$route.query.id
      var query = {
        startDate: this.availableDays[0],
        endDate: this.availableDays[this.availableDays.length - 1],
      }
      return this.$http
        .get(
          `/warehouse-container-settings/shipment/${id}/reserve-warehouses`,
          {
            params: {
              ...query,
            },
          }
        )
        .then((res) => {
          var tempData = res.data.filter((r) => !r.virtualWarehouse)
          tempData.forEach((td) => {
            if ('WORKING_CALENDAR' === td.calendarType) {
              td.availableDays = this.workingAvailableDays
            } else {
              td.availableDays = this.basicAvailableDays
            }
          })
          this.results = this.initData(tempData)
          this.results = this.results.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              warehouseCode: 'desc',
              buId: 'desc',
            })
          })
          this.results.forEach((r) => {
            r = r.sort((a, b) => {
              return this.$sortByProps(a, b, {
                productGroupName: 'desc',
              })
            })
          })
          this.results = this.results.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              seq: 'ascending',
            })
          })
          this.displayResults = this.results
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    initDate() {
      var id = this.$route.query.id
      this.$http
        .get(
          `/warehouse-container-settings/shipment/${id}/available-days?calendarType=WORKING_CALENDAR`
        )
        .then((res) => {
          this.workingAvailableDays = res.data
          this.$http
            .get(
              `/warehouse-container-settings/shipment/${id}/available-days?calendarType=BASIC_CALENDAR`
            )
            .then((bRes) => {
              this.basicAvailableDays = bRes.data
              this.initAvailDays()
            })
        })
        .catch((err) => {
          this.$showError(err)
        })
    },

    initAvailDays() {
      this.workingAvailableDays.forEach((w) => {
        if (this.availableDays.indexOf(w) === -1) {
          this.availableDays.push(w)
        }
      })
      this.basicAvailableDays.forEach((b) => {
        if (this.availableDays.indexOf(b) === -1) {
          this.availableDays.push(b)
        }
      })
      this.availableDays = this.availableDays.sort((a, b) => a.localeCompare(b))
      this.availableDays.forEach((day) => {
        this.headers.push({
          text: day,
          sortable: false,
        })
      })
      if (this.availableDays.length === 0) {
        this.$message(
          'ERROR',
          '正常納入指示期間にありませんので、おまかせ予約ができません。'
        )
      } else {
        this.load()
      }
    },

    initData(data) {
      var a = this.groupBy(data, function (item) {
        return [item.warehouseId, item.buId, item.businessUnitId]
      })
      a = a.sort((x, y) => (x[0].seq || 9999) - (y[0].seq || 9999))
      return a
    },
    groupBy(array, f) {
      let groups = {}
      array.forEach(function (o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function (group) {
        return groups[group]
      })
    },
    getWarehouse(item) {
      return item.warehouseCode + ':' + item.warehouseName
    },
    getBu(item) {
      if (item.companyName) {
        return item.companyName
      }
      return item.buCode + ':' + item.buName
    },
    getBusinessUnit(item) {
      return item.businessUnitName
    },
    getProductGroup(data) {
      var a = this.groupBy(data, function (item) {
        return [item.productGroupName]
      })
      return a
    },
    getUpperLimit(date, dataSource) {
      var setting = dataSource.find((d) => date === d.date)
      if (setting) {
        return setting.upperLimit - setting.used
      }
      return 0
    },
    canVirtualReserve(data, date) {
      return (
        data
          .filter(
            (d) =>
              !d.buCode || d.buCode === this.$route.query.shipments[0].buCode
          )
          .filter(
            (d) =>
              !d.businessUnitId ||
              this.$route.query.shipments.filter(
                (s) => s.businessUnitId !== d.businessUnitId
              ).length === 0
          )
          .filter((d) => d.date === date)
          .filter((d) => d.upperLimit - d.used > 0).length > 0
      )
    },
    canReserve(data, date) {
      return (
        data &&
        data.length > 0 &&
        data[0].availableDays.indexOf(date) !== -1 &&
        data
          .filter(
            (d) =>
              !d.buCode || d.buCode === this.$route.query.shipments[0].buCode
          )
          .filter(
            (d) =>
              !d.businessUnitId ||
              this.$route.query.shipments.filter(
                (s) => s.businessUnitId !== d.businessUnitId
              ).length === 0
          )
          .filter((d) => d.date === date)
          .filter((d) => d.reservable && d.upperLimit - d.used > 0).length > 0
      )
    },
    muliplyReserve(data, date) {
      var difBuShipmentLength = this.$route.query.shipments.filter(
        (s) => s.businessUnitId !== this.user.businessUnitId
      ).length

      if (this.user.careBu && difBuShipmentLength > 0) {
        this.$message(
          '',
          '操作者が属するBU以外のデータを操作するのは許可されません。'
        )
        return
      }

      this.currentData = data
      this.currentDate = date
      var availableDays = data[0].availableDays
      this.simulateWarehouse(availableDays)
      this.$message(
        '',
        'おまかせ予約情報をご確認お願い致します。問題がなければ、保存バターンを押してください。'
      )
    },
    simulateWarehouse(availableDays) {
      var id = this.$route.query.id
      if (this.successShipments.length > 0 || this.failedShipments.length > 0) {
        this.load().then(() => {
          this.successShipments = []
          this.failedShipments = []
          this.currentData = this.findCurrentData()
          this.doSimulateWarehouse(availableDays)
          this.filterData()
        })
      } else {
        this.doSimulateWarehouse(availableDays)
      }
    },
    findCurrentData() {
      var origin = this.currentData[0]
      return this.results.find(
        (r) =>
          r[0].warehouseId === origin.warehouseId &&
          r[0].buId === origin.buId &&
          r[0].businessUnitId === origin.businessUnitId
      )
    },
    doSimulateWarehouse(availableDays) {
      var shipments = this.$route.query.shipments
      shipments.forEach((s) => {
        var settedDate = this.currentDate
        var availableSetting = this.getAvailableSetting(
          s,
          settedDate,
          availableDays
        )
        if (!availableSetting) {
          this.failedShipments.push({
            ...s,
          })
        } else {
          this.successShipments.push({
            shipment: s,
            setting: availableSetting,
          })
        }
      })
    },
    findSetting(productGroupName, date) {
      var availableSettings = this.currentData
        .filter((c) => (c.upperLimit - c.used || 0) > 0)
        .find((c) => {
          return c.productGroupName === productGroupName && c.date === date
        })
      return availableSettings
    },
    checkIfAvailable(setting) {
      return setting && (setting.upperLimit - setting.used || 0) > 0
    },
    getNextDate(availableDays, currentDate) {
      var currentDateIndex = availableDays.indexOf(currentDate)
      if (currentDateIndex + 1 === availableDays.length) {
        return availableDays[currentDateIndex]
      }
      return availableDays[currentDateIndex + 1]
    },
    getAvailableSetting(shipment, settedDate, availableDays) {
      var setting = this.findSetting(shipment.productGroupName, settedDate)
      if (!this.checkIfAvailable(setting)) {
        var newDate = this.getNextDate(availableDays, settedDate)
        if (newDate === settedDate) {
          return null
        }
        setting = this.getAvailableSetting(shipment, newDate, availableDays)
      } else {
        //使用了 used + 1
        setting.used += 1
      }
      return setting
    },
    send(id) {
      return this.$http
        .put(`/delivery-orders/${id}/send-email-date`)
        .then(() => {
          this.$message('', '納入指示済')
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    save() {
      var data = this.successShipments
      var errorMsg = []
      var arr = []
      var i = 0

      this.$http
        .get(
          `/warehouse-container-settings/check-if-long-distance-route/shipment/${data[0].shipment.shipmentId}/warehouse/${data[0].setting.warehouseId}`
        )
        .then((res) => {
          if (res.data) {
            this.$message(
              '',
              'おまかせ：選択されたデータはロングドレジの納入指示なので、明細画面にご予約ください。'
            )
          } else {
            this.dealAutoSet(data, i, errorMsg)
          }
        })
    },
    dealAutoSet(data, i, errorMsg) {
      var setting = data[i].setting
      var id = data[i].shipment.shipmentId
      var remark = data[i].shipment.remark
      this.$http
        .put(`/warehouse-container-settings/shipment/${id}/batch-reserve`, {
          reserveDate: setting.date,
          warehouseId: setting.warehouseId,
          buId: setting.buId,
          businessUnitId: setting.businessUnitId,
          remark: remark,
          vos: [
            {
              ...data[i].setting,
            },
          ],
        })
        .then((res) => {
          this.send(id).then(() => {
            this.doAutoSet(i, data, errorMsg)
            if (!res.data.success) {
              errorMsg.push(res.data.localeMessage)
            }
          })
        })
        .catch((err) => {
          console.log(data[i])
          // this.errors[err.response.data.message]
          errorMsg.push(
            data[i].shipment.containerNo +
              ':' +
              this.errors[err.response.data.message]
          )
          this.doAutoSet(i, data, errorMsg)
        })
    },

    doAutoSet(i, data, errorMsg) {
      if (i < data.length - 1) {
        this.dealAutoSet(data, i + 1, errorMsg)
      } else {
        if (errorMsg.length === 0) {
          this.$router.go(-1)
          this.$message('', '納入指示済')
        }
        if (errorMsg.length > 0) {
          console.log(errorMsg)
          var msg = errorMsg.join(',')
          console.log(msg)
          this.$router.go(-1)
          this.$message('', '予約できません。' + ':' + msg)
        }
      }
    },
    filterData() {
      this.displayResults = this.results.filter(
        (d) =>
          (!this.query.warehouseId ||
            d[0].warehouseId === this.query.warehouseId) &&
          (d[0].companyCode === 'SJL' ||
            !this.query.buId ||
            d[0].buId === this.query.buId) &&
          (d[0].companyCode === 'SJL' ||
            !this.query.businessUnitId ||
            d[0].businessUnitId === this.query.businessUnitId)
      )
      this.virtualDisplayResults = this.virtualWarehouses.filter(
        (d) =>
          (!this.query.warehouseId ||
            d[0].warehouseId === this.query.warehouseId) &&
          (d[0].companyCode === 'SJL' ||
            !this.query.buId ||
            d[0].buId === this.query.buId) &&
          (d[0].companyCode === 'SJL' ||
            !this.query.businessUnitId ||
            d[0].businessUnitId === this.query.businessUnitId)
      )
    },
    getEmployee() {
      this.$http.get(`/employees/current`).then((res) => {
        this.user = res.data
      })
    },
    getVirtualWarehouses() {
      this.$http
        .get(`/warehouse-container-settings/virtual-warehouse-settings`)
        .then((res) => {
          res.data
            .map((r) => r.date)
            .forEach((d) => {
              if (this.virtualAvailDays.indexOf(d) === -1) {
                this.virtualAvailDays.push(d)
              }
            })

          this.virtualAvailDays = this.virtualAvailDays.sort((a, b) =>
            a.localeCompare(b)
          )

          this.virtualAvailDays.forEach((day) => {
            this.virtualHeaders.push({
              text: day,
              sortable: false,
            })
          })

          res.data.forEach((r) => {
            r.availableDays = this.virtualAvailDays
          })

          this.virtualWarehouses = this.initData(res.data)

          this.virtualWarehouses = this.virtualWarehouses.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              warehouseCode: 'desc',
              buId: 'desc',
            })
          })
          this.virtualWarehouses.forEach((r) => {
            r = r.sort((a, b) => {
              return this.$sortByProps(a, b, {
                productGroupName: 'desc',
              })
            })
          })
          this.virtualWarehouses = this.virtualWarehouses.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              seq: 'ascending',
            })
          })

          this.virtualDisplayResults = this.virtualWarehouses
          console.log(res.data)
        })
    },
  },
  watch: {
    'query.warehouseId'() {
      this.filterData()
    },
    'query.buId'() {
      this.filterData()
    },
    'query.businessUnitId'() {
      this.filterData()
    },
  },
  mounted() {
    this.initDate()
    this.getVirtualWarehouses()
  },
}
</script>

<style scoped>
.over-content {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
}
.qtyLeft {
  display: flex;
}

.qtyLeft > div {
  flex: 1;
  text-align: left;
  align-self: center;
}

.reserveBtn {
  flex: 1;
}

.row-1 td {
  padding: 0px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.info-1 {
  display: flex;
  column-gap: 15px;
}

.row-0 {
  display: flex;
}

.col-0,
.col-1 {
  width: 100%;
}

.col-1 {
  border-left: 1px solid #f0f0f0;
  padding: 5px 15px;
}

.header {
  padding-left: 20px;
  text-align: left;
  color: #999;
}
</style>
